var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"za-icon",attrs:{"viewBox":"0 0 24 24","width":_vm.size,"height":_vm.size,"fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true","focusable":"false"},domProps:{"innerHTML":_vm._s(_vm.paths)}})
}
var staticRenderFns = []

export { render, staticRenderFns }